// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-section {
    max-width: 1400px;
    margin: 20px auto;
    padding: 20px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-family: sans-serif;
}

.delete-section h2 {
    text-align: center;
    margin-bottom: 20px;
    color: #333;
}

.group-dropdown {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.group-dropdown label {
    margin-right: 10px;
    font-weight: bold;
    color: #333;
}

.group-dropdown select {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    min-width: 200px;
    font-size: 16px;
}

.specimen-list {
    margin-top: 20px;
}

.specimen-list h3 {
    margin-bottom: 10px;
    color: #333;
}

.specimen-list ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.specimen-list li {
    display: grid;
    grid-template-columns: 9fr 2fr 1fr;
    align-items: center;
    border-bottom: 1px solid #ddd;
    width: 100%;
    padding: 10px 0;
}

.specimen-list li:last-child {
    border-bottom: none;
}

.specimen-list li span {
    font-size: 16px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.specimen-list li button {
    display: inline-block;
    padding: 0 6px;
    height: 30px;
    font-size: 12px;
    background-color: #d9534f;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin: 0;
    box-sizing: border-box;
}

.specimen-list li button:hover {
    background-color: #c9302c;
}

@media (max-width: 768px) {
    .group-dropdown {
        flex-direction: column;
        align-items: flex-start;
    }

    .group-dropdown label {
        margin-bottom: 5px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Delete.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".delete-section {\n    max-width: 1400px;\n    margin: 20px auto;\n    padding: 20px;\n    background: #fff;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    font-family: sans-serif;\n}\n\n.delete-section h2 {\n    text-align: center;\n    margin-bottom: 20px;\n    color: #333;\n}\n\n.group-dropdown {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.group-dropdown label {\n    margin-right: 10px;\n    font-weight: bold;\n    color: #333;\n}\n\n.group-dropdown select {\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    min-width: 200px;\n    font-size: 16px;\n}\n\n.specimen-list {\n    margin-top: 20px;\n}\n\n.specimen-list h3 {\n    margin-bottom: 10px;\n    color: #333;\n}\n\n.specimen-list ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.specimen-list li {\n    display: grid;\n    grid-template-columns: 9fr 2fr 1fr;\n    align-items: center;\n    border-bottom: 1px solid #ddd;\n    width: 100%;\n    padding: 10px 0;\n}\n\n.specimen-list li:last-child {\n    border-bottom: none;\n}\n\n.specimen-list li span {\n    font-size: 16px;\n    color: #333;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.specimen-list li button {\n    display: inline-block;\n    padding: 0 6px;\n    height: 30px;\n    font-size: 12px;\n    background-color: #d9534f;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    margin: 0;\n    box-sizing: border-box;\n}\n\n.specimen-list li button:hover {\n    background-color: #c9302c;\n}\n\n@media (max-width: 768px) {\n    .group-dropdown {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .group-dropdown label {\n        margin-bottom: 5px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
